import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getUnites = async () => {
  const response = await axios.get('/admin/unite/liste')
    .catch((e) => {
      throw new CustomException(e, 'Error fetching unite')
    })
  return response.data
}
